var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('content',[_c('div',{staticClass:"container-xl main-gradient main-block mt-5"},[_c('router-view')],1)]),_c('FooterBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }